__turbopack_context__.v({
  "dropdown": "BlogMenu-module-scss-module__RelVwa__dropdown",
});
